import React, {memo} from "react";
import {TextBold14, TextBold16, TextMedium14} from "@/app/components/texts";
import styles from "./styles.module.scss";
import classNames from "classnames";

interface TextButtonProps {
  text?: string,
  onClick: () => void,
  isMedium?: boolean
  withUnderLine?: boolean
}

const TextButton: React.FC<TextButtonProps> = ({
                                                 text,
                                                 onClick,
                                                 isMedium,
                                                 withUnderLine
                                               }) => {
  return (
    <div
      className={classNames(styles.button, {[styles.medium]: isMedium}, {[styles.withUnderLine]: withUnderLine})}
      onClick={onClick}>
      {isMedium ? <TextMedium14 text={text} className={styles.text}/> :
        <TextBold16 text={text} className={styles.text}/>}
    </div>
  );
};

export default memo(TextButton);